/**
 * @prettier
 */

import { getCardSettings } from 'cards/util/cardSettingsUtils';
import FeatureFlags from '../../util/featureFlags';
import { STEPS, STEPS_ALLOWING_MULTIPLES } from '../constants/Steps';

// eslint-disable-next-line import/prefer-default-export
export const getStepUrl = (projectUUID, step, cardType) => {
  // If no project UUID is specified, URL can't be generated
  if (!projectUUID) return '';

  // If no step id is specified, always select the first step.
  const stepId = step || STEPS.detailFront;

  // When a card type is specified, find the type's url slug.
  let typeSlug;
  if (cardType && STEPS_ALLOWING_MULTIPLES.includes(stepId)) {
    typeSlug = getCardSettings(cardType).urlSlug;
  }

  return typeSlug && FeatureFlags.get('enclosuresInInvitesFlow')
    ? `/wedding-planning/custom/${projectUUID}/${typeSlug}/${stepId}`
    : `/wedding-planning/custom/${projectUUID}/${stepId}`;
};



// WEBPACK FOOTER //
// ./src/cards/util/getStepUrl.js